import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

const VARIANTS = {
  default: "bg-primary/[0.07] text-primary ring-primary/15",
  secondary: "bg-secondary/10 text-brand-600 ring-secondary/25",
  success: "bg-success/10 text-success ring-success/20",
  warning: "bg-warning/15 text-warning-foreground ring-warning/35",
  destructive: "bg-destructive/[0.07] text-destructive ring-destructive/20",
  muted: "bg-muted text-muted-foreground ring-border",
} as const;

export function Badge({
  variant = "default",
  className,
  children,
}: {
  variant?: keyof typeof VARIANTS;
  className?: string;
  children: ReactNode;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center whitespace-nowrap rounded-md px-2 py-0.5 text-xs font-semibold ring-1 ring-inset",
        VARIANTS[variant],
        className,
      )}
    >
      {children}
    </span>
  );
}
